import { Skeleton, Stack } from "@mui/material"

import { TokenImagePlaceholder, useTokenLogo } from "./TokenLogo"
import { TokenInfo } from "../ao/token"

export default function PoolImage({ tokenA, tokenB }: { tokenA?: TokenInfo; tokenB?: TokenInfo }) {
  const {
    data: tokenALogo,
    isLoading: isLoadingA,
    isError: isErrorA,
  } = useTokenLogo({ tx: tokenA?.logo })

  const {
    data: tokenBLogo,
    isLoading: isLoadingB,
    isError: isErrorB,
  } = useTokenLogo({ tx: tokenB?.logo })

  if (isLoadingA || isLoadingB) {
    return <Skeleton width={28} height={28} />
  }

  return (
    <Stack
      direction="row"
      sx={{
        gap: "2px",
        position: "relative",
        size: 28,
      }}
    >
      {isLoadingA || isErrorA || !tokenALogo ? (
        <TokenImagePlaceholder
          style={{
            width: 14,
            height: 28,
            minWidth: 14,
            minHeight: 28,
            fontSize: 12,
            borderRadius: "14px 0px 0px 14px",
            objectPosition: "0px 0px",
          }}
        >
          {tokenA?.ticker.substring(0, 1)}
        </TokenImagePlaceholder>
      ) : (
        <img
          style={{
            borderRadius: "14px 0px 0px 14px",
            objectPosition: "0px 0px",
            width: "14px",
            height: "28px",
            objectFit: "cover",
          }}
          src={tokenALogo}
        />
      )}

      {isLoadingB || isErrorB || !tokenBLogo ? (
        <TokenImagePlaceholder
          style={{
            width: 14,
            height: 28,
            minWidth: 14,
            minHeight: 28,
            fontSize: 12,
            borderRadius: "0px 14px 14px 0px",
            objectPosition: "100% 0px",
          }}
        >
          {tokenB?.ticker.substring(0, 1)}
        </TokenImagePlaceholder>
      ) : (
        <img
          style={{
            borderRadius: "0px 14px 14px 0px",
            objectPosition: "100% 0px",
            width: "14px",
            height: "28px",
            objectFit: "cover",
          }}
          src={tokenBLogo}
        />
      )}
    </Stack>
  )
}
